import slugify from 'slugify';

export function normalise_slug_public_diffusion (pValeur)
  {
    return slugify (pValeur || '',
      {
        lower       : true,
        strict      : true,
        locale      : 'fr',
        replacement : '-',
        trim        : true,
      });
  }

export function slug_public_diffusion_reserve (pSlug)
  {
    const tSlug = normalise_slug_public_diffusion (pSlug);
    if (!tSlug) return true;
    return [
      'api',
      'assets',
      'auth',
      'compte',
      'hype',
      'jouer',
    ].includes (tSlug);
  }
